module.exports = __webpack_public_path__ + "img/frame (168).f1ad3468.jpg";